<script setup>
import { useAttrs, ref } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
const mascotUrl = ref('/secretaria-mascot.png');
</script>

<template>
  <!-- SecretarIA Mascot Logo (yellow cat) -->
  <img
    v-bind="attrs"
    :src="mascotUrl"
    alt="SecretarIA"
    class="object-contain"
  />
</template>
